// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"280":"mainThemeBlue","621":"mainThemeBurgundy"}[chunkId] || chunkId) + "." + {"248":"57b7f0c6","280":"0744db3a","621":"8dffd53a","776":"31665065"}[chunkId] + ".chunk.css";
};